import product from './product';

function Price() {
  return <p className="product-price">{product.price}</p>;
}

export default Price;
